import { Component, inject, Input, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { FileManagerUploadedFilesComponent } from '@features/file-manager-uploaded-files/file-manager-uploaded-files.component';

import { FileManagerComponent } from '@shared/components/file-manager/file-manager.component';
import { InputComponent } from '@shared/components/input/input.component';
import { DocumentType } from '@shared/services/gql.service';
import { MainQuery } from '@shared/store/main/main.query';

@Component({
  imports: [
    InputComponent,
    ReactiveFormsModule,
    FileManagerComponent,
    FileManagerUploadedFilesComponent,
  ],
  selector: 'aux-investigator-transaction-supporting-section',
  template: `
    <div class="grid grid-cols-2 gap-7">
      <div>
        <aux-input
          label="Note"
          inputClassName="grow resize-none"
          class="!flex h-full flex-col text-xs"
          [textArea]="true"
          resize="none"
          [rows]="2"
          [validators]="'required'"
          [formControl]="noteFormControl"
          [showRequiredAsterisk]="true"
          [fieldName]="'Note'"
        />
      </div>
      <div>
        <p class="mb-1 block text-xs">Supporting Documents</p>
        <aux-file-manager
          #fileManager
          class="h-32"
          [fetchFilesOnInit]="false"
          [eager]="false"
          [insertDocument]="false"
        />
        <aux-file-manager-uploaded-files [fileManager]="fileManager" />
      </div>
    </div>
  `,
})
export class InvestigatorTransactionSupportingSectionComponent {
  private mainQuery = inject(MainQuery);

  @ViewChild('fileManager') fileManager?: FileManagerComponent;
  @Input({ required: true }) noteFormControl!: FormControl;

  async saveSupportingSection() {
    if (this.noteFormControl.invalid) {
      return;
    }

    const files =
      this.fileManager?.fileQuery.getAll({ filterBy: ({ uploaded }) => !uploaded }) || [];

    files.forEach((file) => {
      if (file?.rawFile) {
        this.fileManager?.fileStore.update(file.id, {
          ...file,
          bucket_key: `investigator-transactions/${this.mainQuery.getValue().trialKey}/${new Date().toISOString()}_${file.fileName}`,
        });
      }
    });

    await this.fileManager?.fileService.uploadFiles({
      metadata: {
        documentType: DocumentType.DOCUMENT_MANUAL_TRANSACTION_SUPPORT,
      },
    });

    return {
      documents: this.fileManager?.fileQuery.getAll({ filterBy: ({ uploaded }) => uploaded }) || [],
      note: this.noteFormControl.value,
    };
  }
}
